import React from 'react';
import { useTranslation } from 'react-i18next';
import { Facebook, Linkedin, Mail } from 'lucide-react';

const SharePage = () => {
    const { t, i18n } = useTranslation();
    const isAr = i18n.language === 'ar';
    const primaryGreen = "#006C35";

    const shareItems = [
        {
            name: t('share.facebook'),
            icon: <Facebook size={24} />,
            color: "#1877F2",
            href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`
        },
        {
            name: t('share.messenger'),
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.477 2 2 6.145 2 11.258c0 2.908 1.454 5.494 3.727 7.152.196.142.31.37.31.62l.01 2.22c.005.47.534.736.9.43l2.496-2.09c.16-.135.364-.202.57-.184 1.012.092 2.07.142 3.16.142 5.523 0 10-4.145 10-9.258C22 6.145 17.523 2 12 2zm1.09 12.396l-2.433-2.606-4.744 2.606 5.216-5.55 2.484 2.606 4.693-2.606-5.216 5.55z" />
                </svg>
            ),
            color: "#0084FF",
            href: `fb-messenger://share/?link=${encodeURIComponent(window.location.href)}`
        },
        {
            name: t('share.linkedin'),
            icon: <Linkedin size={24} />,
            color: "#0A66C2",
            href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`
        },
        {
            name: t('share.x'),
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
            ),
            color: "#000000",
            href: `https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}`
        },
        {
            name: t('share.pinterest'),
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.965 1.406-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345-.091.377-.293 1.189-.333 1.342-.053.204-.172.248-.396.143-1.472-.684-2.392-2.83-2.392-4.552 0-3.707 2.693-7.111 7.766-7.111 4.076 0 7.246 2.905 7.246 6.788 0 4.048-2.553 7.305-6.095 7.305-1.191 0-2.311-.619-2.695-1.348l-.734 2.793c-.266 1.023-1.002 2.316-1.482 3.102 1.132.339 2.325.518 3.565.518 6.62 0 11.988-5.367 11.988-11.987C24.005 5.367 18.638 0 12.017 0z" />
                </svg>
            ),
            color: "#E60023",
            href: `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(window.location.href)}`
        },
        {
            name: t('share.whatsapp'),
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                </svg>
            ),
            color: "#25D366",
            href: `https://api.whatsapp.com/send?text=${encodeURIComponent(window.location.href)}`
        },
        {
            name: t('share.email'),
            icon: <Mail size={24} />,
            color: "#D44638",
            href: `mailto:?subject=${encodeURIComponent(document.title)}&body=${encodeURIComponent(window.location.href)}`
        },
    ];

    return (
        <section className="py-12 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className={`flex flex-col md:flex-row items-center justify-between gap-8 border-t border-gray-100 pt-12`}>

                    {/* Section Title */}
                    <div className={`text-left`}>
                        <h2 className={`text-2xl font-bold text-gray-900 ${isAr ? 'border-r-4 pr-4' : 'border-l-4 pl-4'}`} style={{ borderColor: primaryGreen }}>
                            {t('share.title')}
                        </h2>
                    </div>

                    {/* Sharing Icons */}
                    <div className={`flex flex-wrap justify-center gap-4`}>
                        {shareItems.map((item, index) => (
                            <a
                                key={index}
                                href={item.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-12 h-12 flex items-center justify-center rounded-xl bg-gray-50 text-gray-400 hover:text-white transition-all duration-300 transform hover:scale-110 shadow-sm"
                                style={{
                                    '--hover-bg': item.color
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = item.color}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
                                aria-label={item.name}
                                title={item.name}
                            >
                                {item.icon}
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SharePage;
